export const STATUS = {
   NOT_USE_YET: 0,
   LIVE: 1,
   STOP_LIVE: 2,
   CRAWLING_COMPLETED: 3,
   STOP_CLOSE_SALE: 4,
   SCANNING_COMMENTS: 5,
   PROCESSED: 6,
   RETRY_CRAWL: 7
}

export const METHOD_TYPE = {
   AUTOMATION: 'Automation',
   RETRIEVE_ORDER_MANUAL: 'RetrieveOrderManual'
}